export const LOGO_ORANGE = 'assets/images/logo/logo-full.png';
export const ORANGE = 'assets/images/logo/logo.png';
